module.exports = __webpack_public_path__ + "img/16.4563725f.jpg";